import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-foundation-modal';
import { connect } from 'react-redux';

class ActionPanelClass extends React.Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 550;
    const {
      children,
      visible = false,
      style = {},
      revealStyle = {},
      overlayStyle = {},
      forcePopup,
      onRequestClose,
      size = 'large',
      mobileWebContainerStyle,
    } = this.props;
    const newStyle = { ...style, maxHeight: '95vh' };
    if (isMobile || forcePopup) {
      const modal = (
        <Modal
          open={visible}
          closeModal={onRequestClose}
          isModal
          closeStyle={{ display: 'none' }}
          revealStyle={{ border: 'none', ...revealStyle }}
          overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', ...overlayStyle }}
          size={size}
        >
          <div style={{
            borderRadius: '20px',
            height: '100%',
            ...mobileWebContainerStyle,
          }}
          >
            {children}
          </div>

        </Modal>
      );
      return ReactDOM.createPortal(modal, document.getElementById('modal-container'));
    } if (visible) {
      const rightContent = document.getElementById('right-content');
      if (rightContent) {
        return ReactDOM.createPortal(<div style={newStyle}>{children}</div>, rightContent);
      }
    }

    return <></>;
  }
}

export const ActionPanel = connect((state) => ({}))(ActionPanelClass);
